// extracted by mini-css-extract-plugin
module.exports = {"auth":"AuthForm_auth__eCNZi","control":"AuthForm_control__gf06f","actions":"AuthForm_actions__3k9P7","toggle":"AuthForm_toggle__3r-MF"};